<div *ngIf="!isHidden && visible" class="container-fluid" [class.d-none]="collapsed">
  <form [formGroup]="form!" class="mt-2">
    <ng-content></ng-content>
  </form>
  <div *ngIf="!isNoButtons" class="d-flex flex-row-reverse mt-2">
    <div class="d-flex flex-fill justify-content-end">
      <div *ngIf="deleted" class="me-2">
        <input-switch [size]="4" labelPosition="left" label="Mostrar os deletados" [hostClass]="'mt-0'" [control]="deletedControl" (change)="onDeletedChange($event)"></input-switch>
      </div>
      <div class="btn-group" role="group" aria-label="Grupo de botões para filtrar e limpar filtro">
        <button type="button" [id]="getId('_filter_filtrar')" class="btn btn-secondary" (click)="onButtonFilterClick()">
          <i class="bi bi-filter-circle"></i> Filtrar
        </button>
        <button *ngIf="nrRows != undefined" [id]="getId('_filter_count')">
          <small [class]="nrRows > 0 ? 'text-success'  : 'text-warning'">{{ nrRows == 0 ? 'Nenhum registro encontrado' : (nrRows == 1 ? '1 registro encontrado' : nrRows + ' registros encontrados') }}</small>
        </button>
        <button type="button" [id]="getId('_filter_limpar')" class="btn btn-light" (click)="onButtonClearClick()">
          <i class="bi bi-x-circle"></i> Limpar
        </button>
      </div>
    </div>
  </div>
</div>